import { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';

const RequireAuth = ({ children }: { children: ReactElement }) => {
    const raw = sessionStorage.getItem('user');
    let parsed: any = null;
    try { parsed = raw ? JSON.parse(raw) : null; } catch { parsed = null; }

    if (!parsed?.isLoggedIn || !parsed?.token) {
        return <Navigate to="/" replace />;
    }
    return children;
};

export { RequireAuth };
